<template>
  <ProSpaceModal
    v-model="localModelValue"
    ref="fileUploadForm"
    class="modal-import"
    icon="plus"
    width="550"
    :needHideApply="false"
    :disabledApply="!filesCount"
    :title="$t('loadingData')"
    :cancelTxt="$t('cancelTxt')"
    :applyTxt="$t('upload')"
    @apply="applyImportForm"
    @close="closeModal"
  >
    <template v-slot:default>
      <ProSpaceGeoLayout>
        <template #center>
          <ProSpaceVLayout :gap="20">
            <ProSpaceDropdown
              :label="$t('addressProgramImportType')"
              :placeholder="$t('addressProgramImportType')"
              :options="importTypeOptions?? getOptions()"
              v-model="importType"
              propLabel="text"
              propValue="value"
              style="max-width: 290px;"
            >
            </ProSpaceDropdown>
            <ProSpaceFile
              ref="fileUploadField"
              :fileLimit="1"
              :maxFileSize="20485760"
              @files-count="filesCountHandler"
              :accept="accept"
              :txtBtnUpload="$t('uploadFile')"
              :txtEmptyFiles="$t('uploadFileDragAndDropText')"
            >
              <template #header>
                <ProSpaceAction
                  icon="download"
                  iconWidth="20px"
                  iconHeight="20px"
                  @click="actionImportScaffold"
                >
                  <span>{{ $t("importTemplate") }}</span>
                </ProSpaceAction>
              </template>
            </ProSpaceFile>
          </ProSpaceVLayout>
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceModal>
  <ProSpaceFlashMessage
    v-model="confirmationModalModel.show"
    class="confirmation-modal"
    :cancelTxt="$t('cancelTxt')"
    :title="$t('adjustmentUnlockTitle')"
    :needHideApply="false"
    :applyTxt="$t('confirmTxt')"
    icon="flash-warning"
    @apply="applyConfirmationModalModel"
    @cancel="refreshConfirmationModalModel"
  >
    <ProSpaceVLayout :gap="10" align-items="center" is-inline-h>
      {{ $t('kpiUploadadjustmentUnlockTxt') }}
      <ProSpaceHLayout justifyContent="center">
        <Checkbox
          class="prospace-checkbox__input"
          v-model="confirmationModalModel.adjustmentUnlock"
          name="adjustmentUnlock"
          inputId="adjustmentUnlock"
          binary
        />
        <label for="adjustmentUnlock"> {{ $t('adjustmentUnlockTxt') }} </label>
      </ProSpaceHLayout>
    </ProSpaceVLayout>
  </ProSpaceFlashMessage>
</template>

<script>
import {
  ProSpaceModal,
  ProSpaceFile,
  ProSpaceGeoLayout,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceLabel,
  ProSpaceAction,
  ProSpaceIcon,
  ProSpaceDropdown,
  ProSpaceFlashMessage
} from "@prospace/prospace-components-library";
import Checkbox from "primevue/checkbox";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FileService } from "../../../../../../Frontends/ProSpace/services/FileService.js";
import { AddressProgramOrderService } from "../../../services/AddressProgramOrderService.js";
import { MarsPeriodService } from "../../../services/MarsPeriodService";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "ModalImport",
  components: {
    ProSpaceModal,
    ProSpaceFile,
    ProSpaceGeoLayout,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceLabel,
    ProSpaceAction,
    ProSpaceIcon,
    ProSpaceDropdown,
    ProSpaceFlashMessage,
    Checkbox
  },
  props: {
    modelValue: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    accept: {
      type: String,
      default: () => {
        return null;
      },
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      filesCount: 0,
      fileService: new FileService(),
      addressProgramOrderService: new AddressProgramOrderService(),
      marsPeriodService: new MarsPeriodService(),
      importTypeOptions: null,
      importType: "",
      confirmationModalModel: {
        show: false,
        adjustmentUnlock: true
      }
    };
  },
  methods: {
    showConfirmationModal() {
      this.confirmationModalModel.show = true;
    },
    applyConfirmationModalModel() {
      this.applyImportForm(true, this.confirmationModalModel.adjustmentUnlock);
      this.refreshConfirmationModalModel();
    },
    refreshConfirmationModalModel() {
      this.confirmationModalModel.show = false;
      this.confirmationModalModel.adjustmentUnlock = true;
    },
    filesCountHandler(evt) {
      this.filesCount = evt;
    },
    applyImportForm(checkedPeriodUnblock = false, adjustmentUnlock = false) {
      if (!checkedPeriodUnblock && this.importType === "KPI_FACT") {
        this.showConfirmationModal();
        return;
      }

      this.$emit("loading", true);
      let formData = new FormData();
      formData.append("", this.$refs["fileUploadField"].files[0]);
      this.$emit("close");
      this.fileService.upload(formData).then((result) => {
        if (result && result.data && result.data.success) {
          var functionName = this.importTypeOptions.find(x=> x.value == this.importType).serviceFunctionName;
          this.addressProgramOrderService[functionName](result.data.data[0].gfid, this.currentPeriod?.id)
            .then((importResult) => {
              if (
                importResult &&
                importResult.data &&
                importResult.data.success
              ) {
                if (this.importType === "KPI_FACT") {
                  let periodUpdateModel = _.cloneDeep(this.currentPeriod);
                  periodUpdateModel.isBlocked = !adjustmentUnlock;
                  this.marsPeriodService.update(periodUpdateModel).then((res) => {
                    this.$store.dispatch("marsPeriodStore/setMarsPeriod", res.data[0]);
                    this.$emit("loading", false);
                  })
                } else {
                  this.$emit("loading", false);
                }
              } else {
                this.$emit("loading", false);
                //TODO: error
              }
            });
        } else {
          //TODO: show error
          this.$emit("loading", false);
        }
      });
      //TODO: Show message(import task created)
    },
    actionImportScaffold() {
      let me = this;
      var functionName =  me.importTypeOptions.find(x=> x.value == me.importType).scaffoldServiceFunctionName;
      me.addressProgramOrderService[functionName]()
        .then((fileResponse, status, xhr) => {
          me.$emit("loading", true);
          if (fileResponse != null) {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(fileResponse.data);
            link.download = fileResponse.headers["content-disposition"]
              .split(";")
              .find((n) => n.includes("filename="))
              .replace("filename=", "")
              .trim();
            link.click();
          }
          me.$emit("loading", false);
        });
    },
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    formatSize(bytes) {
      if (bytes === 0) {
        return "0 B";
      }

      let k = 1000,
        dm = 1,
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    //т.к. модалка маунтится при загрузке грида, нет возможности получить информацию по доступам при маунте компонента
    getOptions() {
      let me = this;
      var result = [];
      if (me.checkAccess && me.checkAccess("import-agencyTerritory")) {
        me.importType = "ADDRESS_PROGRAM_AGENCY_TERRITORY";
        result.push(
          { text: this.$t("addressProgramImportAgencyTerritory"), value: "ADDRESS_PROGRAM_AGENCY_TERRITORY", serviceFunctionName: "importAgencyTerritory", scaffoldServiceFunctionName: "getAgencyTerritoryImportScaffold"  }
        );
      }
      if (me.checkAccess("import-addressProgram")) {
        me.importType = "ADDRESS_PROGRAM";
        result.push({ text: this.$t("addressProgramImportTypePlan"), value: "ADDRESS_PROGRAM", serviceFunctionName: "import", scaffoldServiceFunctionName: "getImportScaffold"  });
        result.push({ text: this.$t("addressProgramImportKPIPlan"), value: "KPI_PLAN", serviceFunctionName: "importKPIPlan", scaffoldServiceFunctionName: "getKPIPlanImportScaffold"  });
        result.push({ text: this.$t("addressProgramImportKPIFact"), value: "KPI_FACT", serviceFunctionName: "importKPIFact", scaffoldServiceFunctionName: "getKPIFactImportScaffold"  });
        result.push({ text: this.$t("addressProgramImportBudgetFact"), value: "BUDGET_FACT", serviceFunctionName: "importBudgetFact", scaffoldServiceFunctionName: "getBudgetFactImportScaffold"  });
      }
      me.importTypeOptions = result;
      return result;
    }
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      currentPeriod: "marsPeriodStore/getMarsPeriod"
    }),
    localModelValue: {
      get() {
        return this.modelValue;
      },
      set(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
    icon() {
      return { faFileUpload };
    },
  }
};
</script>

<style lang="scss">
.modal-import {
  & .p-dialog-content {
    padding: 20px;
  }

  .file-upload {
    max-height: 240px;
    font-weight: 400;
    line-height: 20px;
    font-size: 13px;

    &__wrapper {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border: 1px solid #e0e7f4;
      border-radius: 5px;
      margin: 5px;
    }

    &__empty {
      padding: 20px;
    }

    &__filename {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 294px;
      width: 294px;
      color: #687284;
    }

    &__filesize {
      color: #b0bec5;
    }
  }
}
.confirmation-modal {
  .prospace-modal-wrapper {
    overflow: hidden;
  }
  .prospace-checkbox {
    padding: 8px 15px;
  }
}
</style>
